import React from 'react';
import {View, Text, Image, TouchableOpacity, StyleSheet} from 'react-native-web';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import IconButton from './IconButton';
import paymentIcon from "../icons/DupeIcons-22-Payment.png";
import calendarIcon from "../icons/DupeIcons-23-Calendar.png";
import pencilIcon from "../icons/blue-pencil.png";
import trashcanIcon from "../icons/trash-can.png";
import blueLandscapeIcon from '../icons/blue-landscape-icon.png';
import checkIcon from '../icons/DupeIcons-17-Biz-Available.png';
import photoIcon from "../icons/DupeIcons-14-Photo.png";
import videoIcon from "../icons/DupeIcons-12-Video.png";
import {updateDRollOpenEnrollment} from '../services/DRollService';
import { useEffect, useState } from 'react';
import Switch from "react-switch";

const DRollPreview = ({ droll, alternateBackground, drollOpened, openArchiveModal, archived, restore }) => {
    const navigate = useNavigate();
    const [openEnrollment, setOpenEnrollment] = useState(false);

    const formatDate = () => {
        if (!droll.startDate || !droll.endDate) {
            return 'Dates'
        }
        const monthFormatter = new Intl.DateTimeFormat('default', {month: 'long', day: 'numeric'});
        const startDate = Date.parse(droll.startDate)
        const endDate = Date.parse(droll.endDate)
        return monthFormatter.format(startDate) + ' - ' + monthFormatter.format(endDate)
    }

    const formatPaymentInfo = () => {
        if (droll.id === 'template') {
            return "Payment per submission"
        }
        
        if (droll.paymentCompensation && droll.defaultPayment > 0) {
            return `$${droll.defaultPayment} default payment`;
        } else if (droll.paymentCompensation) {
            return "Payment compensation enabled";
        } else if (droll.productCompensation) {
            return "Product compensation";
        } else if (droll.commissionCompensation) {
            return "Commission compensation";
        } else {
            return "No compensation set";
        }
    }

    const getContentTypes = () => {
        if (droll.id === 'template') {
            return null;
        }
        
        if (!droll.deliverables || droll.deliverables.length === 0) {
            return 'No deliverables';
        }
        
        const contentTypes = [...new Set(droll.deliverables.map(d => d.contentType))];
        const typeLabels = contentTypes.map(type => {
            switch(type) {
                case 'photo': return 'Photos';
                case 'video': return 'Videos';
                case 'instagram_post': return 'IG Posts';
                case 'instagram_story': return 'IG Stories';
                case 'tiktok_video': return 'TikTok';
                case 'youtube_video': return 'YouTube';
                default: return type;
            }
        });
        
        return typeLabels.join(' & ');
    }

    const hasPhotos = () => {
        return droll.deliverables && droll.deliverables.some(d => 
            d.contentType === 'photo' || d.contentType === 'instagram_post'
        );
    }

    const hasVideos = () => {
        return droll.deliverables && droll.deliverables.some(d => 
            d.contentType === 'video' || d.contentType === 'instagram_story' || 
            d.contentType === 'tiktok_video' || d.contentType === 'youtube_video'
        );
    }

    function toggleOpenEnrollment() {
        let req = {};
        req.drollId = droll.id;
        req.open = !openEnrollment;
        updateDRollOpenEnrollment(req)
            .then(resp => {
                if (resp.status === 200) {
                    setOpenEnrollment(!openEnrollment);
                }
            })
    }

    useEffect(() => {
        setOpenEnrollment(droll.open);
    }, [droll.open]);

    return (
        <View style={alternateBackground ? styles.alternateDRollPreviewContainer : styles.drollPreviewContainer}>
            <Image 
                style={styles.drollPreviewImage} 
                source={droll.imageExists 
                    ? {uri: 'https://d3p3fw3rutb1if.cloudfront.net/business/photos/' + droll.id}
                    : blueLandscapeIcon
                }
                defaultSource={blueLandscapeIcon}
                resizeMode="cover"
            />
            <View style={styles.contentContainer}>
                <View style={styles.leftColumn}>
                    <View style={styles.drollInfoContainer}>
                        <View>
                            <Text style={styles.drollNameText}>{droll.name || 'D-Roll Name'}</Text>
                            {getContentTypes() && (
                                <View style={styles.contentTypesContainer}>
                                    {hasPhotos() && <Image source={photoIcon} style={styles.contentTypeIcon} />}
                                    {hasVideos() && <Image source={videoIcon} style={styles.contentTypeIcon} />}
                                    <Text style={styles.contentTypesText}>{getContentTypes()}</Text>
                                </View>
                            )}
                        </View>
                        {drollOpened && (
                            <View style={{flexDirection: 'row', alignItems: 'center'}}>
                                <Text>Open for Submissions</Text>
                                <Switch
                                    onChange={toggleOpenEnrollment}
                                    checked={openEnrollment}
                                    height={15}
                                    width={30}
                                    handleDiameter={14}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    activeBoxShadow={'0 0 2px 3px #3bf'}
                                    onColor={"#396de0"}
                                    className="react-switch"
                                />
                            </View>
                        )}
                        <View>
                            <View style={styles.infoRow}>
                                <Image style={styles.drollPreviewIcon} source={paymentIcon}/>
                                <Text style={styles.subtleText}>{formatPaymentInfo()}</Text>
                            </View>
                            <View style={styles.infoRow}>
                                <Image style={styles.drollPreviewIcon} source={calendarIcon}/>
                                <Text style={styles.subtleText}>{formatDate()}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                {droll.id !== 'template' && <View style={styles.rightColumn}>
                    {!archived && (
                        <View style={styles.statusContainer}>
                            <View>
                                {!drollOpened && <IconButton source={trashcanIcon} onPress={() => {openArchiveModal(droll)}} size={20} accessibilityLabel="Archive D-Roll" containerStyle={{marginRight: 5}} />}
                            </View>
                            <Text style={styles.subtleText}>Public D-Roll</Text>
                            <IconButton source={pencilIcon} onPress={() => {navigate('/drolls/' + droll.slug + '/edit')}} size={16} accessibilityLabel="Edit D-Roll" containerStyle={{marginLeft: 10}} />
                        </View>
                    )}
                    {archived && <Button
                        onPress={() => restore(droll)}
                        text="Restore"
                        variant='tertiary'
                    />}
                    {!drollOpened && (
                        <Button
                            onPress={() => navigate('/drolls/' + (droll.slug || ''))}
                            text="Open D-Roll"
                        />
                    )}
                </View>}
                {droll.id === 'template' && <View style={styles.rightColumn}>
                    <TouchableOpacity 
                        style={[styles.btn, styles.blueBtn]}
                        onPress={() => navigate('/drolls/create')}
                    >
                        <Text style={styles.blueBtnText}>Create D-Roll</Text>
                    </TouchableOpacity>
                </View>}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    contentContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        flex: 1,
    },
    leftColumn: {
        justifyContent: "center",
    },
    drollInfoContainer: {
        justifyContent: 'space-between',
        flex: 0.85,
    },
    rightColumn: {
        justifyContent: 'space-between',
        margin: 10,
    },
    statusContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10,
    },
    drollPreviewContainer: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 120,
    },
    alternateDRollPreviewContainer: {
        backgroundColor: '#f8f9ff',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 120,
    },
    drollPreviewImage: {
        width: 80,
        height: 80,
        borderRadius: 8,
        marginRight: 20,
        backgroundColor: '#f3f4f6',
        borderWidth: 1,
        borderColor: '#e5e7eb',
    },
    drollNameText: {
        color: '#396de0',
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 20,
        fontWeight: '700',
        marginBottom: 8,
    },
    contentTypesContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
    },
    contentTypeIcon: {
        width: 16,
        height: 16,
        marginRight: 4,
        tintColor: '#6b7280',
    },
    contentTypesText: {
        fontSize: 14,
        color: '#6b7280',
        fontFamily: "'lato', sans-serif",
        fontWeight: '500',
        marginLeft: 4,
    },
    infoRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 4,
    },
    drollPreviewIcon: {
        width: 16,
        height: 16,
        marginRight: 8,
        tintColor: '#6b7280',
    },
    subtleText: {
        fontSize: 14,
        color: '#6b7280',
        fontFamily: "'lato', sans-serif",
        fontWeight: '400',
    },
    pencilIcon: {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },
    trashcanIcon: {
        width: 16,
        height: 16,
        tintColor: '#ef4444',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },
    btn: {
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 120,
    },
    blueBtn: {
        backgroundColor: '#396de0',
    },
    blueBtnText: {
        color: 'white',
        fontFamily: "'lato', sans-serif",
        fontSize: 16,
        fontWeight: '600',
    },
});

export default DRollPreview; 